import React, { useMemo, useRef, useState, useEffect } from "react";

/* ===== Proclamation Images ===== */
import Proclamation1 from "../../images/proclamations/proclamation1.jpg";
import Proclamation2 from "../../images/proclamations/proclamation2.jpg";
import Proclamation3 from "../../images/proclamations/proclamation3.jpg";
import Proclamation4 from "../../images/proclamations/proclamation4.jpg";
import Proclamation5 from "../../images/proclamations/proclamation5.jpg";
import Proclamation6 from "../../images/proclamations/proclamation6.jpg";
import Proclamation7 from "../../images/proclamations/proclamation7.jpg";
import Proclamation8 from "../../images/proclamations/proclamation8.jpg";
import Proclamation9 from "../../images/proclamations/proclamation9.jpg";
import Proclamation10 from "../../images/proclamations/proclamation10.jpg";
import Proclamation11 from "../../images/proclamations/proclamation11.jpg";
import Proclamation12 from "../../images/proclamations/proclamation12.jpg"; 
function MediaCarousel({ items = [] }) {
  const [index, setIndex] = useState(0);
  const [selected, setSelected] = useState(null);
  useEffect(() => {
  if (selected) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
}, [selected]);
  const next = () => setIndex((i) => (i + 1) % items.length);
  const prev = () => setIndex((i) => (i - 1 + items.length) % items.length);

  return (
    <div className="coverflow-container">
      <div className="coverflow">
        {items.map((item, i) => {
          let offset = i - index;

            // ✅ Fix looping (important for circular effect)
            if (offset > items.length / 2) offset -= items.length;
            if (offset < -items.length / 2) offset += items.length;

             // ✅ Show only 5 cards
            if (Math.abs(offset) > 2) return null;

  return (
    <div
      key={i}
      className="coverflow-card"
      style={{
        transform: `
          translateX(${offset * 300}px)
          rotateY(${offset * -40}deg)
          scale(${offset === 0 ? 1 : 0.85})
        `,
        zIndex: 10 - Math.abs(offset),
      }}
      onClick={() => {
  if (i === index) {
    setSelected(item.image); // ✅ open modal if center
  } else {
    setIndex(i); // move clicked card to center
  }
}}
    >
      <img src={item.image} alt="" />

      
    </div>
  );
})}
      </div>
      

      <div className="coverflow-info">
  <button className="cf-nav" onClick={prev}>‹</button>

  <div className="info-center">
    <h2>{items[index].title}</h2>
    <button onClick={() => setSelected(items[index].image)}>
      View
    </button>
  </div>

  <button className="cf-nav" onClick={next}>›</button>
</div>

      {/* MODAL */}
      {selected && (
  <div className="popup-widget" onClick={() => setSelected(null)}>
    <div
      className="popup-widget-content"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="popup-close"
        onClick={() => setSelected(null)}
      >
        ×
      </button>

      <img src={selected} alt="Preview" />
    </div>
  </div>
)}
    </div>
  );
}


/* =========================================================
   MAIN PAGE
========================================================= */
function ProclamationsPage() {

  const proclamations = useMemo(
    () => [
      { title: "CITY OF MILPITAS", image: Proclamation1 },
      { title: "17th CONGRESSIONAL DISTRICT OF CALIFORNIA", image: Proclamation2 },
      { title: "CITY OF FREMONT", image: Proclamation3 },
      { title: "THE CITY OF SUNNYVALE CALIFORNIA", image: Proclamation4 },
      { title: "CITY OF MILPITAS", image: Proclamation5 },
      { title: "FOG PROCLAMATIONS", image: Proclamation6 },
      { title: "FOG PROCLAMATIONS", image: Proclamation7 },
      { title: "FOG PROCLAMATIONS", image: Proclamation8 },
      { title: "FOG PROCLAMATIONS", image: Proclamation9 },
      { title: "FOG PROCLAMATIONS", image: Proclamation10 },
      { title: "FOG PROCLAMATIONS", image: Proclamation11 },
      { title: "FOG PROCLAMATIONS", image: Proclamation12 },
    ],
    []
  );

  return (
    <>
      <style>{`
       /* CONTAINER */
.coverflow-container {
  position: relative;
  perspective: 1200px;
  margin-top: 60px;
}
.white {
  font-size: 48px;
  font-weight: 900;
  line-height: 1.2;
}
/* FLOW */
.coverflow {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 450px;
  position: relative;
  transform-style: preserve-3d;
}

/* CARD */
.coverflow-card {
  position: absolute;
  width: 340px;
  height: 340px;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
  cursor: pointer;
  background: #000;
}

.coverflow-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* GLASS INFO */
.glass-panel {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 16px;
  backdrop-filter: blur(12px);
  background: rgba(0,0,0,0.4);
  color: #fff;
  text-align: center;
}

.glass-panel h2 {
  font-size: 18px;
  margin-bottom: 10px;
}

.glass-panel button {
  padding: 8px 18px;
  border-radius: 20px;
  border: none;
  background: #ff6600;
  color: white;
  cursor: pointer;
}


/* FULL SCREEN OVERLAY */
.popup-widget {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.75);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 999999;
}

/* CHANGE THIS COMPLETELY */
.popup-widget-content {
  position: relative;

  width: auto;
  max-width: 700px;     /* 🔥 key */
  max-height: 90vh;

  background: #fff;     /* 🔥 white card */
  border-radius: 12px;

  padding: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* IMAGE FIX */
.popup-widget-content img {
  width: 100%;
  height: auto;
  max-height: 80vh;

  object-fit: contain;
  border-radius: 6px;
}

/* CLOSE BUTTON */
.popup-close {
  position: absolute;
  top: 10px;
  right: 10px;

  width: 35px;
  height: 35px;

  border-radius: 50%;
  border: none;

  background: #666;
  color: #fff;
  font-size: 18px;

  cursor: pointer;
}
/* CLOSE BUTTON */
.modal-close {
  position: absolute;
  top: 20px;
  right: 20px;

  width: 40px;
  height: 40px;

  border-radius: 50%;
  border: none;

  background: rgba(255,255,255,0.2);
  color: white;
  font-size: 18px;

  cursor: pointer;
}
.coverflow-info {
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
}

/* CENTER CONTENT */
.info-center {
  text-align: center;
}

/* TITLE */
.info-center h2 {
  font-size: 28px;
  font-weight: 900;
  text-transform: uppercase;

  color: #111;

  text-shadow:
    0 1px 0 #fff,
    0 2px 8px rgba(0,0,0,0.15);

  margin-bottom: 10px;
}

/* BUTTON */
.info-center button {
  padding: 10px 26px;
  border-radius: 30px;
  border: none;
  background: linear-gradient(135deg, #ff9933, #ff6600);
  color: white;
  cursor: pointer;
}
/* ONLY carousel buttons */
.coverflow-container .cf-nav {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.4);

  background: rgba(255,255,255,0.2);
  backdrop-filter: blur(12px);

  color: #333;
  font-size: 24px;
  font-weight: bold;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  box-shadow:
    0 8px 20px rgba(0,0,0,0.15),
    inset 0 1px 2px rgba(255,255,255,0.6);

  transition: all 0.3s ease;
}

.coverflow-container .cf-nav:hover {
  transform: scale(1.15);
  background: linear-gradient(135deg, #ff9933, #ff6600);
  color: white;

  box-shadow:
    0 10px 30px rgba(255,102,0,0.4),
    0 0 15px rgba(255,153,51,0.5);
}

.coverflow-container .cf-nav:active {
  transform: scale(0.95);
}
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
/* =========================
   MOBILE VERSION
========================= */
@media (max-width: 768px) {

  /* Page spacing */
  .coverflow-container{
    margin-top: 20px;
  }

  /* Keep heading fully below fixed navbar */
  h1.white{
    font-size: 20px !important;
    line-height: 1.3 !important;
    margin-top: 8px !important;
    margin-bottom: 0 !important;
    padding: 0 8px;
  }

  .white.mt-3{
    font-size: 14px !important;
    line-height: 1.6;
    margin-top: 10px !important;
  }

  /* Divider */
  .section-divider{
    margin: 12px auto 16px;
    gap: 10px;
  }

  .section-divider span{
    font-size: 16px;
  }

  .section-divider::before,
  .section-divider::after{
    height: 2px;
  }

  /* Carousel area */
.coverflow{
  height: 360px;
  overflow: visible;
}

/* Cards */
.coverflow-card{
  width: 260px;
  height: 260px;
  border-radius: 16px;
}

  /* Reduce spacing between cards */
  .coverflow-card{
    transition: all .45s ease;
  }

  /* Info section */
  .coverflow-info{
    margin-top: 15px;
    gap: 15px;
  }

  .info-center{
    width: 180px;
  }

  .info-center h2{
    font-size: 15px;
    line-height: 1.3;
    margin-bottom: 8px;
  }

  .info-center button{
    padding: 8px 18px;
    font-size: 13px;
  }

  /* Navigation buttons */
  .coverflow-container .cf-nav{
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  /* Popup */
  .popup-widget{
    padding: 10px;
  }

  .popup-widget-content{
    width: 95%;
    max-width: 95%;
    padding: 10px;
    border-radius: 10px;
  }

  .popup-widget-content img{
    max-height: 75vh;
  }

  .popup-close{
    width: 30px;
    height: 30px;
    font-size: 16px;
    top: 5px;
    right: 5px;
  }
}
      `}</style>

      <section className="block color-scheme-4">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-9 text-center">
              <h1 className="white"><strong>FOG Proclamations & Recognitions</strong>
              <div className="section-divider">
  <span>✦ ✦ ✦</span>
</div>
              </h1>

              <p className="white mt-3">
                Festival of Globe has received numerous proclamations,
                commendations, and official recognitions from cities and
                government leaders across the United States.
              </p>

              <MediaCarousel
                items={proclamations}
                ariaLabel="Proclamations slideshow"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProclamationsPage;